import { Capacitor } from "@capacitor/core";

// True only when running inside the native iOS/Android (Capacitor) app.
// Used to hide in-app purchasing on native for App Store / Play Store compliance
// (Apple Guideline 3.1.1) — subscriptions are managed on the web at getwyvn.com.
export function isNativeApp() {
  try {
    return Capacitor?.isNativePlatform?.() === true;
  } catch {
    return false;
  }
}

// True on phones, native, touch devices, or when the user prefers reduced motion.
// Used to skip GPU-heavy effects (WebGL globe, parallax) that stall mobile devices.
export function isLowPowerClient() {
  try {
    if (isNativeApp()) return true;
    if (typeof window === "undefined") return false;
    if (window.location && /[?&]lite=1/.test(window.location.search)) return true;
    const mm = window.matchMedia;
    const reduced = mm && mm("(prefers-reduced-motion: reduce)").matches;
    const coarse = mm && mm("(pointer: coarse)").matches;
    const small = window.innerWidth < 1024;
    return Boolean(reduced || small || coarse);
  } catch {
    return false;
  }
}
